export default __webpack_public_path__ + "static/review-tab-842d6b0634d8d438423b6f02b3bb0ddb.svg";